<div class="upload-container" [class.no-padding-bottom]="isSubmitted">
  <div class="upload-info" (click)="fileInput.click()">
    <label class="upload-label">
      {{quarterlyFeedback.fileLabel}}
      <span class="valid-file-info">{{fileTypeText || quarterlyFeedback.assetFileType}}</span>
    </label>
    <emerald-button [type]="'Light'">{{quarterlyFeedback.browseFile}}</emerald-button>
    <input
      type="file"
      class="file-input"
      [attr.accept]="accept"
      (change)="handleFileChange($event)"
      #fileInput
    />
  </div>
  <div class="field-error" *ngIf="error">
    <span class="field-error-message">{{ error }}</span>
  </div>
  <div *ngIf="selectedFile || existingFileUrl" class="selected-file">
    <emerald-icon [icon]="'insert_drive_file'"></emerald-icon>
    <div class="file-info">
      <span class="file-name">{{ selectedFile?.name || fileName || getFileNameFromUrl(existingFileUrl) }}</span>
      <emerald-icon [icon]="'check_circle'"></emerald-icon>
      <span class="file-size" *ngIf="selectedFile && selectedFile.size">({{ formatFileSize(selectedFile.size) }}) </span>
    </div>
    <emerald-icon [icon]="'delete'" (click)="removeFile()"></emerald-icon>
  </div>
</div>
